import { configureStore, createListenerMiddleware, TypedAddListener } from '@reduxjs/toolkit'
import {
  closeFeedback,
  feedback,
  nextFeedback,
} from '../../components/Feedback/feedback';
import { AppDispatch, AppStartListening, RootState } from '../store';

let timeoutId = 0;

const speed = 6000;
const fast = 4000;

const listenerMiddlewareFeedback = createListenerMiddleware()
// export const startistening = listenerMiddlewareFeedback.startListening as AppStartListening;
// export const addAppListener = addListener as TypedAddListener< RootState, AppDispatch>

// Feedback Push

listenerMiddlewareFeedback.startListening( {
  actionCreator: feedback,
  effect: async( action, listenerApi ) => {

    const state = listenerApi.getState() as RootState;

    if( state.feedback.open ) return;

    listenerApi.dispatch( nextFeedback() );

  }
})

// Close

listenerMiddlewareFeedback.startListening( {
  actionCreator: closeFeedback,
  effect: async( action, listenerApi ) => {

    const state = listenerApi.getState() as RootState;

    if( timeoutId ) clearTimeout( timeoutId );

    if( state.feedback.queue.length ) {
      setTimeout( () => {
        listenerApi.dispatch( nextFeedback() );
      }, 200 );
    }
  }
})

// Next

listenerMiddlewareFeedback.startListening( {
  actionCreator: nextFeedback,
  effect: async( action, listenerApi ) => {

    const state = listenerApi.getState() as RootState;

    timeoutId = window.setTimeout( () => {
      listenerApi.dispatch( closeFeedback() )
    }, speed );
  }
})

export default listenerMiddlewareFeedback;
